<template>

  <v-main>
    <v-row justify="center" align="center" style="height: 100%;" no-gutters>
        
        <div class="wrapper" elevation-5>

          <v-row no-gutters class="py-12 px-12" justify="center" align="center">
            <v-progress-circular size="32" width="2.5" indeterminate></v-progress-circular>
          </v-row>

        </div>
    </v-row>
  </v-main>

</template>

<script>

import axios from "axios";

export default {
    nome: "Direct",
    data: () => ({
    }),
    mounted(){

      try {
        const { token } = this.$route.query;
        if(token) return this.signinVendedor(token);
      } catch (error) {
        console.log(error);
      }
      
    },
    methods: {
      async signinVendedor(token){

        try {
          const request = await axios.post(`${process.env.VUE_APP_API_URL}/api/v1/public/auth/signin/token`, { token });
          const { payload } = request.data;
          const { roomID } = this.$route.query;

          localStorage.setItem('@bsi:user', JSON.stringify(payload));
          localStorage.setItem('@bsi:token', token);

          if(roomID) this.$router.push({path: `/principal/${payload.empresa_id}/room/${roomID}`, params: { roomID } });

        } catch (error) {
          console.log(error);
        }


      }
    }
}
</script>

<style lang="scss">
 
  main{
    background-color: #ccccd4;
    height: 100%;

    .wrapper{

      border-radius: 12px;

      .close{
          position: absolute;
          right: 15px;
          top: 15px;
          opacity: .8;
          transition: all .2s ease-in-out;
          cursor: pointer;
          &:hover{
            opacity: 1;
          }
      }

    }
  }

</style>
